<template>
<div class="bg-color-dynamic">  
<div class="container container-fix">
    <div class="row">
        <div class="col-lg-12 text-center">
        
            <div class="row">
                <div class="col-sm-6 col-6-custom no-padding col-img-product-carousel">
                    <div id="carousel-tajwid" class="carousel slide carousel-product" data-ride="carousel">
                    <ol class="carousel-indicators">
                        <li v-for="index in carousels.length" data-target="#carousel-tajwid" :data-slide-to="index" :class="index == 0 ? ' active' : ''"></li>
                    </ol>
                    <div class="carousel-inner">
                        <div v-for="[index, carousel] of carousels.entries()" :class="'carousel-item' + (index == 0 ? ' active' : '')">
                            <img class="d-block w-100 img-carousel" v-lazy="carousel"/>
                            <div v-lazy:background-image="carousel"></div>
                        </div>
                    </div>
                    <a class="carousel-control-prev" href="#carousel-tajwid" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carousel-tajwid" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                    </div>
                </div>
                <div class="col-sm-6 col-6-custom desc-product">
                    
                    <h2 class="tagline-product-1">                        
                        {{ $t('tajwidTagline1') }}  <br/> {{ $t('tajwidTagline1Row2') }} <span class="font-bold">{{ $t('tajwidTagline1Bold') }}</span> <div> {{ $t('tajwidTagline1AfterBold') }}</div>
                    </h2>
                    <div class="d-flex flex-row justify-content-around">
                        <div class="feature-points-wrapper">
                            <div v-for="point in pointsKeyLeft" class="feature-point">
                                <img class="checklist tinted-image-check" v-lazy="imgObjCek"/>
                                <span v-t="{path: point}"></span>
                                <div v-lazy:background-image="imgObjCek"></div>
                            </div>
                        </div>
                        <div class="feature-points-wrapper">
                            <div v-for="point in pointsKeyRight" class="feature-point">
                                <img class="checklist tinted-image-check" v-lazy="imgObjCek"/>
                                <span v-t="{path: point}"></span>
                                <div v-lazy:background-image="imgObjCek"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product-buttons-wrapper">
                        <div dir="ltr" class="d-flex flex-row justify-content-center align-items-center" style="column-gap: 0.5rem;">
                            <button onclick="window.open('./link/tajwidAndroid','_blank')" class="d-block btn btn-outline-custom w-100 btn-bg-custom-cta-playstore"></button>
                            <button onclick="window.open('./link/tajwidIOS','_blank')" class="d-block btn btn-outline-custom w-100 btn-bg-custom-cta-appstore"></button>
                        </div>
                        <button onclick="window.open('./link/linkTajwidWeb','_blank')" class="btn btn-outline-custom btn-block btn-dark-mode-aware" v-t="{path: 'learnMoreTajwid'}"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
import { createImageObject } from '@/utils/utils';

import imgTajwid1 from '@/assets/img/products/tajwid1.png';
import imgTajwid2 from '@/assets/img/products/tajwid2.png';
import imgTajwid3 from '@/assets/img/products/tajwid3.png';
// Locale specific optimized webp assets
import arImgTajwid1 from '@/assets/img/products/ar-lqtajwid-1.webp';
import arImgTajwid2 from '@/assets/img/products/ar-lqtajwid-2.webp';
import arImgTajwid3 from '@/assets/img/products/ar-lqtajwid-3.webp';
import idImgTajwid1 from '@/assets/img/products/id-lqtajwid-1.webp';
import idImgTajwid2 from '@/assets/img/products/id-lqtajwid-2.webp';
import idImgTajwid3 from '@/assets/img/products/id-lqtajwid-3.webp';
import imgCek from '@/assets/img/products/cek.png';

export default {
   name: 'ProductContentLQTajwid',
    data() {
        return {
            // feature points & checklist image remain static in data
            pointsKeyLeft: ['poin1Tajwid', 'poin2Tajwid', 'poin5Tajwid'],
            pointsKeyRight: ['poin3Tajwid', 'poin4Tajwid'],
            imgObjCek: createImageObject(imgCek),
        }
    },
    computed: {
        // Build carousel images based on locale.
        // Priority:
        // 1. Indonesian ("id") -> use Indonesian webp set (id-lqtajwid-*.webp)
        // 2. Arabic ("ar") -> use Arabic webp set (ar-lqtajwid-*.webp)
        // 3. Fallback -> original PNG assets
        carousels() {
            const locale = (this.$i18n && this.$i18n.locale ? this.$i18n.locale : '').toLowerCase();
            let sources;
            if (locale.startsWith('id')) {
                sources = [idImgTajwid1, idImgTajwid2, idImgTajwid3];
            } else if (locale.startsWith('ar')) {
                sources = [arImgTajwid1, arImgTajwid2, arImgTajwid3];
            } else {
                sources = [imgTajwid1, imgTajwid2, imgTajwid3];
            }
            return sources.map(src => createImageObject(src));
        }
    }
}
</script>

<style scoped>

.tinted-image-check {
    --image-filter-tinted-image-check: brightness(0) saturate(100%) invert(17%) sepia(100%) saturate(400%) hue-rotate(143deg) brightness(94%) contrast(95%);

    filter: var(--image-filter-tinted-image-check)!important;
}

body.dark .tinted-image-check {
   --image-filter-tinted-image-check: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%); 
}

body.force-dark .tinted-image-check {
   --image-filter-tinted-image-check: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%); 
}

@media (width: 568px) {
    .offset-custom-mini {
        margin-left: 10%;
    }
}

@media (min-width: 568px) {
    .col-6-custom {
        -webkit-box-flex: 0!important;
        flex: 0 0 50%!important;
        max-width: 50%!important;
    }    
}

.col-img-product-carousel {
    display: flex;
    align-items: center;
}

.container-fix {
    padding-bottom: 2rem;    
    padding-top: 0!important;
}

.bg-color-dynamic {
    --afterclick-bg-color: white;
    background-color: var(--afterclick-bg-color) !important;

}
body.dark .bg-color-dynamic {
  --afterclick-bg-color: #022534!important;
}

body.force-dark .bg-color-dynamic {
  --afterclick-bg-color: #022534!important;
}

mark {
    display: inline-block;
    line-height: 0em;
    padding-bottom: 0.5em;
    background-color: rgba(241, 176, 130, 0.35);
}

.bg-orange-lq-1 {
    /* background-color: #c3e6cb!important; */
    background-color: rgba(195, 230, 203, 0.3);
    color:#155724!important;
    /* color: black!important; */
    border-radius: 20rem!important;
}
.text-orange-lq-1 {
    /* color: #ff7000!important; */
    color: #155724!important;
    /* color: black!important; */
}

.tagline-product-1 {
    --text-color: #053448!important;
    /* font-weight:100;     */
    color: var(--text-color, #053448)!important;
    font-family: 'QuattrocentoRegular', 'Rubik', sans-serif;
    padding-top: 3rem;
    padding-bottom: 2rem;    
    font-size: 1.5rem!important;
}

body.dark .tagline-product-1 {
  --text-color: white!important;  
}

body.force-dark .tagline-product-1 {
  --text-color: white!important;  
}

@media (min-width: 992px) {
    .tagline-product-1 {
        font-size: 2rem!important;
        font-size: 1.2rem;
    }
}

li {
      font-family: 'QuattrocentoSansRegular', 'Rubik', sans-serif;
}


/* carousel style */
.carousel-control-prev-icon {    
    background-image: url('/assets/img/arrow/left.png');
    min-height: 1.7rem;
}

.carousel-control-next-icon {
    background-image: url('/assets/img/arrow/right.png');
    min-height: 1.7rem;    
}

/* start indicators */

.carousel-indicators li {
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    text-indent: 0;
    cursor: pointer;
    border: 1px solid #03374d;
    border-radius: 50%;
}
.carousel-indicators .active {
    background-clip: initial!important;
    width: 0.5rem;
    height: 0.5rem;
    background-color: #03374d;
}
/* end carousel style */

.img-carousel {
    max-width: 100%!important;
    height: 100%!important;
}

.img-carousel[lazy=loading] {
    padding:30%;
}

.img-carousel[lazy=error] {
    padding:30%;
}


.img-cta {
    max-height: 3rem;
}

.no-padding-dynamic {
    padding-left: 0!important;
    padding-right: 0!important;
}

.check-point-li {
    padding-left: 0!important;
    padding-right: 0!important;
}

@media (min-width: 375px) {
    .img-cta {
        max-height: 3.5rem;
    }
}

@media (min-width: 992px) {
    .img-carousel {
        max-width: 85%!important;
        height: 100%!important;
    }
    .text-product-2 {
        margin: 4.5rem;
        margin-top: 0;
        margin-bottom: 1.5rem;
    }
    .appstore {
        padding-left: auto;
    }
    .cta-learn-more {
        padding-top: 1rem;
    }
    .img-cta {
        max-height: 3.5rem;
    }
    .no-padding-dynamic {
        padding-left: 15px!important;
        padding-right: 15px!important;
    }
}

.appstore {
    padding-left: 0;
}

.carousel-control-next {
    width: 1rem;
}

.carousel-control-prev {
    width: 1rem;
}

.no-padding {
    padding:0!important;
}
.padding-top-cta {
    padding-top: 1.5rem;
}
.button-cta-download {
    margin-bottom: 1rem;
}
.font-bold {
    font-family: 'QuattrocentoSansRegular', 'Rubik', sans-serif;
    font-weight: 700!important;
}

.text-product-2 {
    font-size: 1rem;
    font-family: 'RobotoLight';
    font-weight: 400!important;
}

.checklist {
    max-width:1.5rem;
    margin-right:0.5rem;
    max-height: 1.5rem;
    filter: brightness(0) saturate(100%) invert(15%) sepia(53%) saturate(1820%) hue-rotate(159deg) brightness(94%) contrast(91%);
}

.li-display {
    display: inherit!important;
}


.no-padding-point {
    padding:0!important;
    font-family: 'RobotoLight';
    font-weight: 300!important;
}

.cta-learn-more {
        padding-top: 1rem;
    }

.btn-bg-custom-cta-playstore {
    background-image: url('/assets/img/products/playstore-btn-long.png')!important;
    background-size: cover;
    background-position: center;
    border: 2px solid black;
    background-color: black;
}

.btn-bg-custom-cta-appstore {
    background-image: url('/assets/img/products/appstore-btn-long.png');
    background-size: cover;
    background-position: center;
    border: 2px solid black;
    background-color: black;
}

.btn-bg-custom-cta-playstore:hover {
  background-image: url('/assets/img/products/playstore-btn-mini.png')!important;
    background-size: cover;
    background-position: center;
    border: 2px solid black;
    background-color: black;
    opacity: 0.8;
}

.btn-bg-custom-cta-appstore:hover {
  background-image: url('/assets/img/products/appstore-btn-mini.png')!important;
    background-size: cover;
    background-position: center;
    border: 2px solid black;
    background-color: black;
    opacity: 0.8;
}

.btn-dark-mode-aware {
    --btn-text-color: #053448;
    --btn-border-color: #053448;
    --btn-hover-text-color: white;
    --btn-hover-bg-color: #053448;
    color: var(--btn-text-color);
    border-color: var(--btn-border-color);
}

body.dark .btn-dark-mode-aware {
    --btn-text-color: white;
    --btn-border-color: white;
    --btn-hover-text-color: #022534;
    --btn-hover-bg-color: white;
}

body.force-dark .btn-dark-mode-aware {
    --btn-text-color: white;
    --btn-border-color: white;
    --btn-hover-text-color: #022534;
    --btn-hover-bg-color: white;
}

.btn-dark-mode-aware:hover {
    color: var(--btn-hover-text-color) !important;
    background-color: var(--btn-hover-bg-color) !important;
    border-color: var(--btn-border-color) !important;
}
</style>
